import { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { fetchCuestionarioById } from '../../api/cuestionariosApi';

const parseRespuestas = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch (_e) { return {}; }
  }
  return typeof value === 'object' ? value : {};
};

const unwrapEntity = (payload) => payload?.data ?? payload;

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return `${String(d.getDate()).padStart(2, '0')}-${String(d.getMonth() + 1).padStart(2, '0')}-${d.getFullYear()}`;
};

export const useCuestionarioVentViewer = ({ idCuestionario, paciente }) => {
  const [patientInfo, setPatientInfo] = useState({ nombre: '', apellidos: '', createdAt: '' });
  const [fields, setFields] = useState({
    fumador: '',
    cigarrosDia: '',
    aniosDeshabituacion: '',
    ejercicio: '',
    actividadFisica: '',
    pef: '',
  });
  const [openGood, setOpenGood] = useState(false);

  useEffect(() => {
    if (!idCuestionario) return;
    fetchCuestionarioById(idCuestionario, paciente)
      .then((rawData) => {
        const data = unwrapEntity(rawData);
        const r = parseRespuestas(data.respuestas);
        setPatientInfo({
          nombre: data?.paciente?.firstname || '',
          apellidos: data?.paciente?.lastname || '',
          createdAt: formatDate(data.createdAt),
        });
        setFields({
          fumador: r.fumador || '',
          cigarrosDia: r.cigarrosDia || '',
          aniosDeshabituacion: r.aniosDeshabituacion || '',
          ejercicio: r.ejercicio || '',
          actividadFisica: r.actividadFisica || '',
          pef: r.pef || '',
        });
      })
      .catch(console.error);
  }, [idCuestionario, paciente]);

  const handleExportPDF = () => {
    const input = document.getElementById('pdf-content');
    html2canvas(input, {
      scale: 2,
      backgroundColor: null,
      useCORS: true,
      ignoreElements: (el) => el.tagName === 'BUTTON',
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`cuestionario_vent_${patientInfo.nombre}${patientInfo.apellidos}_${patientInfo.createdAt}.pdf`);
      })
      .catch(console.error);
  };

  return {
    patientInfo,
    fields,
    openGood,
    setOpenGood,
    handleExportPDF,
  };
};
